import { GameConfiguration, QuickReferenceSection } from './types';
import { vinhosModuleQuickReference } from './moduleContent';
import { reserve2010QuickReference } from './reserve-2010';
import { filterByConfiguration } from './contentFilter';
export const vinhosQuickReferenceSections: QuickReferenceSection[] = [
{id:'year',title:'Rok — kolejność',content:'1. Odkrycie rocznika (od 2. roku). 2. Odświeżenie ekspertów/magnatów w 4. i 6. roku. 3. Pierwsza akcja każdego gracza. 4. Aktualizacja kolejności. 5. Druga akcja. 6. Aktualizacja kolejności. 7. Utrzymanie. 8. Starzenie. 9. Produkcja. 10. Targi po 3., 5. i 6. roku.',chapterId:'year-structure'},
{id:'movement',title:'Ruch na Quadrelu',content:'Sąsiadujące pole: 0. Niesąsiadujące: 1 bago do banku. Każdy gracz na polu docelowym: 1 bago dla niego. Znacznik roku/podatku na polu: +1 bago do banku. Pass / Press Release: wejście bez kosztu.',chapterId:'main-actions'},
{id:'production',title:'Produkcja',content:'Najpierw przesuń stare wina o 1 pole w prawo. Następnie każda posiadłość z winnicą produkuje 1 wino: winnice + winiarnie + pracownicy + pogoda + efekty. Nowe wino trafia na lewe pole magazynu/piwnicy.',chapterId:'wine-production'},
{id:'sales',title:'Sprzedaż',content:'Wybierz wino, spełnij próg pola, ewentualnie użyj renomy, odrzuć wino, połóż beczkę i pobierz korzyść finansową. Podczas utrzymania zabierz dokładnie 1 własną beczkę ze sprzedaży.',chapterId:'bank-money'},
{id:'export',title:'Eksport',content:'Wybierz wino spełniające próg, ewentualnie użyj renomy, odrzuć wino, połóż beczkę na wolnym polu eksportu i zdobądź VP.',chapterId:'export'},
{id:'fair',title:'Press Release i targi',content:'Wystaw dokładnie 1 wino. Zdobądź Fair Points za wartość, zajmij stanowisko i weź premię. Dopasuj cechy ekspertów do rocznika. Sprawdź magnatów. Targi: po 3., 5. i 6. roku.',chapterId:'wine-fairs'},
{id:'experts',title:'Eksperci',content:'Odwróć eksperta zakryty, aby użyć zdolności. Zakryci odświeżają się przed 4. i 6. rokiem. Eksperci odrzuceni na targach nie odświeżają się.',chapterId:'experts'},
{id:'end',title:'Koniec gry',content:'Po targach w 6. roku rozlicz eksport, kafle punktacji, magnatów/moduły i przeliczniki końcowe. Nie punktuj automatycznie pozostałych win.',chapterId:'final-scoring'},
{id:'forgotten',title:'Najczęściej zapominane reguły',content:'Nie zostawaj na tym samym polu Quadrelu (poza Pass). Płać innym graczom na polu docelowym. Najpierw starzenie, potem produkcja. Przy utrzymaniu zabierz dokładnie 1 beczkę ze sprzedaży. Na targi wystaw dokładnie 1 wino. Odrzuceni eksperci nie wracają przy odświeżeniu. Bagos ≠ VP.',chapterId:'common-mistakes'},
...vinhosModuleQuickReference,
].map((section) =>
  section.requiredVariantIds?.length
    ? section
    : { ...section, requiredVariantIds: ['special-vintage-2016' as const] }
).concat(reserve2010QuickReference);


export function filterQuickReferenceForModules(
  items: QuickReferenceSection[],
  activeModuleIds: string[] | GameConfiguration
) {
  if (!Array.isArray(activeModuleIds)) {
    return filterByConfiguration(items, activeModuleIds);
  }
  return items.filter(
    (i) =>
      (!i.requiredModuleIds?.length ||
        i.requiredModuleIds.every((id) => activeModuleIds.includes(id))) &&
      (!i.requiredVariantIds?.length ||
        i.requiredVariantIds.includes('special-vintage-2016'))
  );
}

export function filterQuickReferenceForConfiguration(
  config: GameConfiguration,
  items: QuickReferenceSection[] = vinhosQuickReferenceSections
) {
  return filterByConfiguration(items, config);
}
